import React from 'react';
import { Button, ButtonProps, Icon, Tooltip } from '@material-ui/core';
import { PlayerAction } from '@screens/players/button.bar/types/player.action.type';

interface PlayerActionButtonProps extends ButtonProps {
  data: PlayerAction;
}

export function PlayerActionButton({ data, ...rest }: PlayerActionButtonProps) {
  return (
    <Tooltip title={data.text} aria-label={data.text}>
      <Button aria-label={data.text} {...rest}>
        <Icon>{data.icon}</Icon>
      </Button>
    </Tooltip>
  );
}
